import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { FooterSectionComponent } from './components/footer-section/footer-section.component';
import { HeaderComponent } from './components/header/header.component';
import { FloatingServicesComponent } from './components/floating-services/floating-services.component';
import { GetReadySectionComponent } from './pages/home/components/get-ready-section/get-ready-section.component';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { HeroSectionComponent } from './pages/home/components/hero-section/hero-section.component';
import { AtsResumeSectionComponent } from './pages/home/components/ats-resume-section/ats-resume-section.component';
import { AutomateSectionComponent } from './pages/home/components/automate-section/automate-section.component';
import { JobSeekersSectionComponent } from './pages/home/components/job-seekers-section/job-seekers-section.component';
import { OptimizeLinkedinSectionComponent } from './pages/home/components/optimize-linkedin-section/optimize-linkedin-section.component';
import { ResumeBuilderSectionComponent } from './pages/home/components/resume-builder-section/resume-builder-section.component';
import { ServicesSectionComponent } from './pages/home/components/services-section/services-section.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/login/components/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/login/components/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/login/components/reset-password/reset-password.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScanCvComponent } from './pages/scan-cv/scan-cv.component';
import { ScanLinkedinComponent } from './pages/scan-linkedin/scan-linkedin.component';
import { ScanLinkedinResultComponent } from './pages/scan-linkedin-result/scan-linkedin-result.component';
import { ScanResultComponent } from './pages/scan-result/scan-result.component';
import { ResumeBuilderStepsSectionComponent } from './pages/home/components/resume-builder-steps-section/resume-builder-steps-section.component';
import { CardComponent } from './components/card/card.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { CarouselModule } from 'primeng/carousel';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';

import { TokenInterceptor } from './services/interceptors/token-interceptor/token.interceptor';
import { StepsModule } from 'primeng/steps';
import { EditorModule } from 'primeng/editor';
import { WorkCounterComponent } from './components/work-counter/work-counter.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GetStartComponent } from './pages/generate resume/get-start/get-start.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CircleProgressComponent } from './components/circle-progress/circle-progress.component';
import { CareerCoachComponent } from './pages/career-coach/career-coach.component';
import { PricingComponent } from './pages/career-coach/components/pricing/pricing.component';
import { DialogModule } from 'primeng/dialog';
import { CertificatesComponent } from './pages/career-coach/components/certificates/certificates.component';
import { ContentDialogComponent } from './components/content-dialog/content-dialog.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ResmeTargetComponent } from './pages/generate resume/generate-cv-steps/component/resme-target/resme-target.component';
import { GenerateCVStepsComponent } from './pages/generate resume/generate-cv-steps/generate-cv-steps.component';
import { CvTempletesComponent } from './pages/generate resume/generate-cv-steps/component/cv-templetes/cv-templetes.component';
import { EducationComponent } from './pages/generate resume/generate-cv-steps/component/education/education.component';
import { PersonalDataComponent } from './pages/generate resume/generate-cv-steps/component/personal-data/personal-data.component';
import { SelectResumeComponent } from './pages/generate resume/generate-cv-steps/component/select-resume/select-resume.component';
import { SkillsComponent } from './pages/generate resume/generate-cv-steps/component/skills/skills.component';
import { WorkExperienceComponent } from './pages/generate resume/generate-cv-steps/component/work-experience/work-experience.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { TagModule } from 'primeng/tag';
import { GalleriaModule } from 'primeng/galleria';

import { PaymentComponent } from './pages/payment/payment.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { ReviewResumeComponent } from './pages/generate resume/generate-cv-steps/component/review-resume/review-resume.component';
import { ArticalComponent } from './pages/artical/artical.component';
import { ArticalDetailsComponent } from './pages/artical/components/artical-details/artical-details.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GenerateLinkedinProfileComponent } from './pages/generate-linkedin-profile/generate-linkedin-profile.component';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { analyticsID } from 'src/app/models/baseURL';
import { tagID } from 'src/app/models/baseURL';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { VirtualInterviewComponent } from './pages/virtual-interview/virtual-interview.component';
import { CreateCoverLetterComponent } from './pages/create-cover-letter/create-cover-letter.component';
import { ScanCoverletterComponent } from './pages/scan-coverletter/scan-coverletter.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonaallDataComponent } from './pages/profile/personaall-data/personaall-data.component';
import { GeneratedcvComponent } from './pages/profile/generatedcv/generatedcv.component';
import { ChangepasswordComponent } from './pages/profile/changepassword/changepassword.component';
import { FaqhomeComponent } from './pages/home/components/faqhome/faqhome.component';
import { CareerComponent } from './pages/home/career/career.component';
import { EvaluatedcvsComponent } from './pages/profile/evaluatedcvs/evaluatedcvs.component';
import { CvEvaluationComponent } from './pages/profile/evaluatedcvs/cv-evaluation/cv-evaluation.component';
import { VideoTutorialComponent } from './components/video-tutorial/video-tutorial.component';
import { GeneratedcoverlettersComponent } from './pages/profile/generatedcoverletters/generatedcoverletters.component';
import { EvaluatedlinkdinComponent } from './pages/profile/evaluatedlinkdin/evaluatedlinkdin.component';
import { LinkdinEvaluationComponent } from './pages/profile/evaluatedlinkdin/linkdin-evaluation/linkdin-evaluation.component';
import { ClJobDetailsPopUpComponent } from './pages/profile/generatedcv/cl-job-details-pop-up/cl-job-details-pop-up.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { VirtualInterviewStepsComponent } from './pages/virtual-interview/virtual-interview-steps/virtual-interview-steps.component';
import { UploadResumeComponent } from './pages/virtual-interview/components/upload-resume/upload-resume.component';
import { OpportunityDetailsComponent } from './pages/virtual-interview/components/opportunity-details/opportunity-details.component';
import { VrTrailsComponent } from './pages/virtual-interview/components/vr-trails/vr-trails.component';

import { PopupCvComponent } from './pages/virtual-interview/components/popup-cv/popup-cv.component';
import { InterviewSessionComponent } from './pages/virtual-interview/components/interview-session/interview-session.component';
import { InterviewQuestionComponent } from './pages/virtual-interview/components/interview-question/interview-question.component';
import { InterviewResultComponent } from './pages/virtual-interview/components/interview-result/interview-result.component';
import { EvaluatedinterviewComponent } from './pages/profile/evaluatedinterview/evaluatedinterview.component';
import { IntrviewprofileResultComponent } from './pages/profile/evaluatedinterview/intrviewprofile-result/intrviewprofile-result.component';
import { GeneratedlinkdinComponent } from './pages/profile/generatedlinkdin/generatedlinkdin.component';

import { JoblistComponent } from './components/joblist/joblist.component';
import { DeletePopupComponent } from './components/delete-popup/delete-popup.component';
import { CustomTableComponent } from './pages/company/company-dashboard/shared-components/custom-table/custom-table.component';
import { JobVacancyComponent } from './pages/company/company-dashboard/main-page/job-vacancy/job-vacancy.component';
import { AddJobComponent } from './pages/company/company-dashboard/main-page/job-vacancy/add-job/add-job.component';
import { CompanyProfileAdminComponent } from './pages/company/company-dashboard/main-page/company-profile-admin/company-profile-admin.component';
import { CompanyAdminSidebarComponent } from './pages/company/company-dashboard/shared-components/company-admin-sidebar/company-admin-sidebar.component';
import { PositionTableComponent } from './pages/company/company-dashboard/main-page/position/position-table/position-table.component';
import { PositionFormComponent } from './pages/company/company-dashboard/main-page/position/position-form/position-form.component';

import { AllApplicationsComponent } from './pages/company/company-dashboard/main-page/all-applications/all-applications.component';
import { CompanyReviewsComponent } from './pages/company/company-dashboard/main-page/company-reviews/company-reviews.component';
import { ReviewCardComponent } from './pages/company/company-dashboard/main-page/company-reviews/components/review-card/review-card.component';

import { UserProfileComponent } from './pages/company/company-frontend/main-pages/user-profile/user-profile.component';
import { ProfileHeaderComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-header/profile-header.component';
import { ProfileAboutComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-about/profile-about.component';
import { ProfileCompletionComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-completion/profile-completion.component';
import { ProfileExperienceComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-experience/profile-experience.component';
import { ProfileEducationComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-education/profile-education.component';
import { ProfileSkillsComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-skills/profile-skills.component';
import { ProfileContactComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-contact/profile-contact.component';
import { ProfileStatsComponent } from './pages/company/company-frontend/main-pages/user-profile/components/profile-stats/profile-stats.component';
import { CompanyProfileComponent } from './pages/company/company-frontend/main-pages/company-profile/company-profile.component';
import { CompanyJoblistComponent } from './pages/company/company-frontend/main-pages/company-profile/components/company-joblist/company-joblist.component';
import { CompanyOverviewComponent } from './pages/company/company-frontend/main-pages/company-profile/components/company-overview/company-overview.component';
import { UesrJobListComponent } from './pages/company/company-frontend/main-pages/jobs/uesr-job-list/uesr-job-list.component';
import { JopDescriptionComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/jop-description.component';
import { ApplyLayoutComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/apply/apply-layout/apply-layout.component';
import { JobQuestionsComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/apply/steps/job-questions/job-questions.component';
import { UploadCvComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/apply/steps/upload-cv/upload-cv.component';
import { AppliedJobsComponent } from './pages/profile/applied-jobs/applied-jobs.component';
import { AppDetailsComponent } from './pages/company/company-dashboard/main-page/app-details/app-details.component';
import { InterviewSetupComponent } from './pages/company/company-dashboard/main-page/interview-setup/interview-setup.component';
import { SearchComponent } from './pages/search/search.component';
import { CompanyVirtualInterviewComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/company-virtual-interview.component';
import { StartInterviewComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/components/start-interview/start-interview.component';
import { VrInterviewResultComponent } from './pages/company/company-dashboard/main-page/interview/vr-interview-result/vr-interview-result.component';
import { ProfileOverviewComponent } from './pages/profile/profile-overview/profile-overview.component';
import { StartSessionComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/components/start-session/start-session.component';
import { SessionQuestionComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/components/session-question/session-question.component';
import { VirtualInterviewsComponent } from './pages/company/company-dashboard/main-page/virtual-interviews/virtual-interviews.component';
import { InterviewResultsComponent } from './pages/company/company-dashboard/main-page/interview-results/interview-results.component';
import { VrMainComponent } from './pages/company/company-dashboard/main-page/vr-main/vr-main.component';

import { CompanyHomeComponent } from './pages/company/company-home/company-home.component';
import { JobPostHomeComponent } from './pages/company/job-post-home/job-post-home.component';
import { ComingSoonSectionComponent } from './pages/company/company-home/components/coming-soon-section/coming-soon-section.component';
import { StartAchievingSectionComponent } from './pages/company/company-home/components/start-achieving-section/start-achieving-section.component';
import { HireBetterSectionComponent } from './pages/company/company-home/components/hire-better-section/hire-better-section.component';
import { BillingPaymentsComponent } from './pages/company/company-dashboard/main-page/billing-payments/billing-payments.component';
import { BillingServiceDetailsComponent } from './pages/company/company-dashboard/main-page/billing-service-details/billing-service-details.component';
import { BillingJobPostingDetailsComponent } from './pages/company/company-dashboard/main-page/billing-job-posting-details/billing-job-posting-details.component';
import { BillingTalentPurchaseComponent } from './pages/company/company-dashboard/main-page/billing-talent-purchase/billing-talent-purchase.component';
import { BillingVirtualPurchaseComponent } from './pages/company/company-dashboard/main-page/billing-virtual-purchase/billing-virtual-purchase.component';
import { WhyTopTeamsComponent } from './pages/company/shared/why-top-teams/why-top-teams.component';
import { VirtualBillingComingSoonComponent } from './pages/company/company-dashboard/main-page/virtual-billing-coming-soon/virtual-billing-coming-soon.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LandingComponent,
    GetReadySectionComponent,
    HeaderComponent,
    FloatingServicesComponent,
    FooterSectionComponent,
    HeroSectionComponent,
    AtsResumeSectionComponent,
    AutomateSectionComponent,
    HeroSectionComponent,
    JobSeekersSectionComponent,
    OptimizeLinkedinSectionComponent,
    ResumeBuilderSectionComponent,
    ServicesSectionComponent,
    ScanCvComponent,
    ProfileComponent,
    GeneratedcvComponent,
    ChangepasswordComponent,
    ScanLinkedinComponent,
    ScanLinkedinResultComponent,
    PersonalDataComponent,
    ScanResultComponent,
    ResumeBuilderSectionComponent,
    ResetPasswordComponent,
    PersonaallDataComponent,
    ResumeBuilderStepsSectionComponent,
    CardComponent,
    GetStartComponent,
    ScanCoverletterComponent,
    ContactComponent,
    WorkCounterComponent,
    LoginComponent,
    ForgetPasswordComponent,
    OtpCodeComponent,
    ResetPasswordComponent,
    SignUpComponent,
    CircleProgressComponent,
    CareerCoachComponent,
    PricingComponent,
    CertificatesComponent,
    ContentDialogComponent,
    ResmeTargetComponent,
    GenerateCVStepsComponent,
    DialogComponent,
    VideoTutorialComponent,
    CvTempletesComponent,
    CareerComponent,
    SelectResumeComponent,
    PersonalDataComponent,
    WorkExperienceComponent,
    EducationComponent,
    SkillsComponent,
    PaymentComponent,
    ComingSoonComponent,
    ReviewResumeComponent,
    ArticalComponent,
    ArticalDetailsComponent,
    GenerateLinkedinProfileComponent,
    VirtualInterviewComponent,
    CreateCoverLetterComponent,
    FaqhomeComponent,
    EvaluatedcvsComponent,
    CvEvaluationComponent,
    GeneratedcoverlettersComponent,
    EvaluatedlinkdinComponent,
    LinkdinEvaluationComponent,
    ClJobDetailsPopUpComponent,
    VirtualInterviewStepsComponent,
    UploadResumeComponent,
    OpportunityDetailsComponent,
    VrTrailsComponent,
    InterviewResultComponent,
    IntrviewprofileResultComponent,
    PopupCvComponent,
    InterviewSessionComponent,
    InterviewQuestionComponent,
    EvaluatedinterviewComponent,
    GeneratedlinkdinComponent,
    CompanyProfileComponent,
    DeletePopupComponent,
    CompanyJoblistComponent,
    CompanyOverviewComponent,
    JoblistComponent,
    CustomTableComponent,
    JobVacancyComponent,
    AddJobComponent,
    CompanyProfileAdminComponent,
    CompanyAdminSidebarComponent,
    PositionTableComponent,
    PositionFormComponent,
    UesrJobListComponent,
    JopDescriptionComponent,
    AllApplicationsComponent,
    CompanyReviewsComponent,
    ReviewCardComponent,
    ApplyLayoutComponent,
    JobQuestionsComponent,
    UploadCvComponent,
    UserProfileComponent,
    ProfileHeaderComponent,
    ProfileAboutComponent,
    ProfileCompletionComponent,
    ProfileExperienceComponent,
    ProfileEducationComponent,
    ProfileSkillsComponent,
    ProfileContactComponent,
    ProfileStatsComponent,
    AppliedJobsComponent,
    AppDetailsComponent,
    InterviewSetupComponent,
    SearchComponent,
    CompanyVirtualInterviewComponent,
    StartInterviewComponent,
    VrInterviewResultComponent,
    ProfileOverviewComponent,
    StartSessionComponent,
    SessionQuestionComponent,
    VirtualInterviewsComponent,
    InterviewResultsComponent,
    VrMainComponent,
    CompanyHomeComponent,
    JobPostHomeComponent,
    ComingSoonSectionComponent,
    StartAchievingSectionComponent,
    HireBetterSectionComponent,
    BillingPaymentsComponent,
    BillingServiceDetailsComponent,
    BillingJobPostingDetailsComponent,
    BillingTalentPurchaseComponent,
    BillingVirtualPurchaseComponent,
    WhyTopTeamsComponent,
    VirtualBillingComingSoonComponent
  ],
  imports: [
    MatProgressBarModule,
    InputSwitchModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    StepsModule,
    DropdownModule,
    InputMaskModule,
    AccordionModule,
    EditorModule,
    SelectButtonModule,
    BrowserModule,
    TagModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CommonModule,
    CarouselModule,
    MatDialogModule,
    GalleriaModule,
    AnimateOnScrollModule,
    NgCircleProgressModule.forRoot(),
    TranslateModule,
    DialogModule,
    OAuthModule.forRoot(),
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot(analyticsID),
    NgxGoogleAnalyticsRouterModule.forRoot(),
    GoogleTagManagerModule.forRoot({
      id: tagID,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
